const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:5000';

function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
}

export async function createOrGetVenue(payload) {
  const body = {
    capacity: 500,
    country: 'Kenya',
    ...payload
  };

  const response = await fetch(`${API_BASE}/api/admin/venues`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(body)
  });

  const data = await response.json();
  if (response.ok && data?.data?.venue?.id) {
    return data.data.venue.id;
  }

  if (data?.data?.venue?.id) {
    return data.data.venue.id;
  }

  const searchTerm = encodeURIComponent(payload.name || payload.address || '');
  const searchRes = await fetch(`${API_BASE}/api/admin/venues?search=${searchTerm}&limit=5`, {
    headers: authHeaders()
  });
  if (searchRes.ok) {
    const searchData = await searchRes.json();
    const match = searchData.data?.venues?.find(
      (v) =>
        v.name?.toLowerCase() === payload.name?.toLowerCase() ||
        v.address?.toLowerCase() === payload.address?.toLowerCase()
    );
    if (match) return match.id;
    if (searchData.data?.venues?.[0]) return searchData.data.venues[0].id;
  }

  throw new Error(data?.message || 'Failed to save venue');
}

export async function resolveVenueForEvent({
  locationType,
  onlineUrl,
  locationData,
  manualVenue
}) {
  if (locationType === 'online') {
    const url = onlineUrl?.trim();
    let host = 'Online';
    try {
      host = new URL(url).hostname.replace(/^www\./, '');
    } catch {
      host = url.slice(0, 60);
    }
    return createOrGetVenue({
      name: `Online - ${host}`,
      address: url,
      city: 'Online'
    });
  }

  if (locationType === 'tba') {
    return createOrGetVenue({
      name: 'Venue To Be Announced',
      address: 'To be announced',
      city: 'TBA'
    });
  }

  if (manualVenue?.name?.trim() && manualVenue?.address?.trim() && manualVenue?.city?.trim()) {
    const lat = manualVenue.latitude ? parseFloat(manualVenue.latitude) : null;
    const lng = manualVenue.longitude ? parseFloat(manualVenue.longitude) : null;
    return createOrGetVenue({
      name: manualVenue.name.trim(),
      address: manualVenue.address.trim(),
      city: manualVenue.city.trim(),
      coordinates: lat != null && lng != null && !Number.isNaN(lat) && !Number.isNaN(lng)
        ? { lat, lng }
        : null
    });
  }

  if (locationData) {
    const cityComponent = locationData.addressComponents?.find(
      (comp) => comp.types.includes('locality') || comp.types.includes('administrative_area_level_1')
    );
    const city = cityComponent?.long_name || manualVenue?.city || 'Unknown City';
    const venueName = locationData.name || locationData.address.split(',')[0] || 'Venue';
    return createOrGetVenue({
      name: venueName,
      address: locationData.address,
      city,
      coordinates:
        locationData.lat != null && locationData.lng != null
          ? { lat: locationData.lat, lng: locationData.lng }
          : null
    });
  }

  throw new Error('Location is required');
}
